document.addEventListener('alpine:init', () => {
  // Mobile Menu
  Alpine.store('mobileMenu', {
    show: false,
    init() {
      this.adjustPosition()
    },
    open() {
      this.adjustPosition()
      document.body.classList.add('overflow-hidden')
      this.show = true
    },
    close() {
      document.body.classList.remove('overflow-hidden')
      this.show = false
    },
    adjustPosition() {
      const header = document.querySelector('#shopify-section-header')
      if (header) {
        const fromTop = header.offsetHeight + header.getBoundingClientRect().top
        document.querySelector('.menu-drawer').style.top = `${fromTop}px`
      }
    }
  })

  // Product Popup
  Alpine.store('productPopup', {
    currentSize: 'XS/S',
    currentTab: 'sizeGuide',
    init() {
      this.updateSize()
    },
    updateSize() {
      const activeSize = document.querySelector('.size-input:checked')
      if (activeSize) this.currentSize = activeSize.value
    }
  })
})